<script>
  import { fade } from "svelte/transition";
  import ErrorIcon from "./ErrorIcon.svelte";
  import CloseIcon from "./CloseIcon.svelte";

  export let error = "";
  export let title = "";
  let showToast = true;
</script>

{#if showToast}
  <article class="error" role="alert" transition:fade>
    <ErrorIcon width="1.1em" />
    <div class="text">
      {title}:
      <strong>{error}</strong>
    </div>

    <button class="close" on:click={() => (showToast = false)}>
      <CloseIcon width="0.8em" />
    </button>
  </article>
{/if}

<style>
  article {
    color: white;
    padding: 0.75rem 1.5rem;
    border-radius: 0.5rem;
    display: flex;
    align-items: center;
    margin: 0 auto 0.5rem auto;
    width: 80%;
    max-width: 400px;
    box-shadow: rgba(99, 99, 99, 0.3) 0px 2px 8px 0px;
  }
  .error {
    background: IndianRed;
  }
  .text {
    margin-left: 0.5rem;
  }
  button {
    color: white;
    background: transparent;
    border: 0 none;
    padding: 0;
    margin: 0 0 0 auto;
    line-height: 1;
    font-size: 1rem;
  }
</style>
